import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from '../src/pages/Home.js';
import About from '../src/pages/About.js';
import Product from '../src/pages/Product.js';
import Material from '../src/pages/Material.js';
import Contact from '../src/pages/Contact.js';
import IntermediateProducts from './pages/IntermediateProducts.js';
import PaperCupFans from './pages/PaperCupFans.js';
import PaperCup from './pages/PaperCup.js';
import DisposalContainer from './pages/DisposalContainer.js';
import SplashScreen from './layout/SplashScreen.js';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SplashScreen />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Product />} />
        <Route path="/materials" element={<Material />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/intermediate-products" element={<IntermediateProducts />} />
        <Route path="/paper-cup-fans" element={<PaperCupFans />} />
        <Route path="/paper-cup" element={<PaperCup />} />
        <Route path="/disposal-container" element={<DisposalContainer />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;